import { KonvaEventObject } from "konva/lib/Node";
import { useRef } from "react";

import { Point } from "../types";
import { getCenter, getDistance } from "../utils";

export function usePinchAndPanMobile() {
  const lastCenter = useRef<Point | null>(null);
  const lastDist = useRef(0);

  const handleTouchMove = (event: KonvaEventObject<TouchEvent>) => {
    event.evt.preventDefault();

    const touch1 = event.evt.touches[0];
    const touch2 = event.evt.touches[1];

    if (touch1 && touch2) {
      const p1 = { x: touch1.clientX, y: touch1.clientY };
      const p2 = { x: touch2.clientX, y: touch2.clientY };

      if (!lastCenter.current) {
        lastCenter.current = getCenter(p1, p2);
        return;
      }
      const newCenter = getCenter(p1, p2);
      const dist = getDistance(p1, p2);

      if (!lastDist.current) {
        lastDist.current = dist;
      }

      // Calculate local coordinates of center point
      const pointTo = {
        x: (newCenter.x - event.currentTarget.x()) / event.currentTarget.scaleX(),
        y: (newCenter.y - event.currentTarget.y()) / event.currentTarget.scaleX(),
      };

      const scale = event.currentTarget.scaleX() * (dist / lastDist.current);

      event.currentTarget.scale({ x: scale, y: scale });

      // Calculate new stage position
      const dx = newCenter.x - lastCenter.current.x;
      const dy = newCenter.y - lastCenter.current.y;

      const newPos = {
        x: newCenter.x - pointTo.x * scale + dx,
        y: newCenter.y - pointTo.y * scale + dy,
      };

      event.currentTarget.position(newPos);

      lastDist.current = dist;
      lastCenter.current = newCenter;
    }
  };

  const handleTouchEnd = () => {
    lastDist.current = 0;
    lastCenter.current = null;
  };

  return {
    handleTouchMove,
    handleTouchEnd,
  };
}
